import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_date_value = _resolveComponent("date-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_boxed_value = _resolveComponent("boxed-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_wrap_table_with_show_more = _resolveComponent("wrap-table-with-show-more");
  const _component_line_chart = _resolveComponent("line-chart");
  const _component_bar_chart = _resolveComponent("bar-chart");
  const _component_bar_line_chart = _resolveComponent("bar-line-chart");
  const _component_evolution_chart_modal = _resolveComponent("evolution-chart-modal");
  const _component_table_with_title = _resolveComponent("table-with-title");
  return _openBlock(), _createBlock(_component_table_with_title, {
    title: "Evolution",
    class: "advertising-period-table",
    onDownload: $options.downloadPerformancePeriodCSV,
    onCopy: $options.copyPerformancePeriodCSV,
    onGoogleSheetDownload: $options.downloadPerformanceGoogleSheet,
    fields: $data.fields,
    loading: $props.loading,
    onChartModalOpen: _cache[5] || (_cache[5] = $event => $data.chartModal = true)
  }, {
    "period-selector": _withCtx(() => [_renderSlot(_ctx.$slots, "period-selector")]),
    "chart-modal": _withCtx(() => [$data.chartEngine ? (_openBlock(), _createBlock(_component_evolution_chart_modal, {
      key: 0,
      modelValue: $data.chartModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.chartModal = $event),
      options: _ctx.TABBED_FIELDS,
      items: $options.items,
      onModalShown: $options.onChartModalShown,
      chartEngine: $data.chartEngine,
      onRechart: _cache[3] || (_cache[3] = keys => $options.handleRechart(keys)),
      periodEndOf: $data.APP_PERIOD_DROPDOWN_ELEMENTS?.[_ctx.period?.toUpperCase()]?.endOf,
      onRefreshChart: $options.refreshChart,
      onResize: _cache[4] || (_cache[4] = ({
        width,
        height
      }) => _ctx.resizeChart(width, height))
    }, {
      "line-chart": _withCtx(({
        x2Label,
        metricColor,
        showEvolution
      }) => [_createVNode(_component_line_chart, {
        ref: "chart",
        data: $options.chartConfig?.data,
        options: $options.chartConfig?.options,
        x2Label: x2Label,
        showEvolution: showEvolution,
        "metric-color": metricColor
      }, null, 8, ["data", "options", "x2Label", "showEvolution", "metric-color"])]),
      "bar-chart": _withCtx(({
        x2Label,
        metricColor,
        showEvolution
      }) => [_createVNode(_component_bar_chart, {
        ref: "chart",
        data: $options.chartConfig?.data,
        options: $options.chartConfig?.options,
        showEvolution: showEvolution,
        "metric-color": metricColor,
        x2Label: x2Label
      }, null, 8, ["data", "options", "showEvolution", "metric-color", "x2Label"])]),
      "bar-line-chart": _withCtx(({
        x2Label,
        metricColor,
        showEvolution
      }) => [_createVNode(_component_bar_line_chart, {
        ref: "chart",
        data: $options.chartConfig?.data,
        options: $options.chartConfig?.options,
        showEvolution: showEvolution,
        "metric-color": metricColor,
        x2Label: x2Label
      }, null, 8, ["data", "options", "showEvolution", "metric-color", "x2Label"])]),
      _: 1
    }, 8, ["modelValue", "options", "items", "onModalShown", "chartEngine", "periodEndOf", "onRefreshChart"])) : _createCommentVNode("", true)]),
    default: _withCtx(() => [_createVNode(_component_wrap_table_with_show_more, {
      modelValue: $options.period_pager,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $options.period_pager = $event),
      period: _ctx.period
    }, {
      default: _withCtx(() => [_createVNode(_component_b_table_lite, {
        class: "lite-table lite-table-hoverable period-table listing-table",
        fields: $data.fields,
        bordered: "",
        responsive: "",
        fixed: "",
        items: $options.items,
        "sticky-header": true,
        tbodyTrClass: item => _ctx.handleRowClass(item, $options.items),
        onRowClicked: _cache[0] || (_cache[0] = item => _ctx.handleRowClicked(item, $options.handleDateReset, $options.handleDateClick, 'period_agg'))
      }, {
        "head()": _withCtx(col => [_createVNode(_component_flex_row, {
          id: `advertising-period-table-${col?.label}`,
          styles: {
            justifyContent: col.field.justify,
            ...col.field.thStyle
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            target: `advertising-period-table-${col?.label}`,
            style: {
              width: '100%'
            }
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
            }, null, 8, _hoisted_1)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              innerHTML: col?.column === 'period_agg' ? $options.getPeriodColumnTitle : col?.label,
              class: "title"
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1032, ["target"])]),
          _: 2
        }, 1032, ["id", "styles"])]),
        "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_AppIcon, {
            icon: `zoom-${row.item.selected ? 'out' : 'in'}`,
            color: row.item.selected ? null : '#ADADAD',
            size: 16
          }, null, 8, ["icon", "color"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(period_agg)": _withCtx(row => [_createVNode(_component_date_value, {
          value: row.item?.period_agg,
          format: $options.getDateValueFormat,
          styles: {
            justifyContent: 'flex-start',
            ..._ctx.activateDateValueStyles(row)
          },
          loading: $props.loading
        }, null, 8, ["value", "format", "styles", "loading"])]),
        "cell(spend)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 4
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}spend_evol`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}spend_evol`],
                color: color,
                "show-sign": "",
                charCount: $options.maxCharCount.percentage?.[`${_ctx.evolCategory[_ctx.periodCategory]}spend_evol`]
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              tight: "",
              align: "left",
              value: row.item?.spend,
              color: "var(--market-600)",
              min: $options.minMax?.spend?.min,
              max: $options.minMax?.spend?.max,
              loading: $props.loading,
              width: $options.maxCharCount?.currency?.spend
            }, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: row.item?.spend,
                charCount: $options.maxCharCount?.currency?.spend
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading", "width"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(sponsored_sales)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 4
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}sponsored_sales_evol`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}sponsored_sales_evol`],
                color: color,
                "show-sign": "",
                charCount: $options.maxCharCount.percentage?.[`${_ctx.evolCategory[_ctx.periodCategory]}sponsored_sales_evol`]
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              tight: "",
              align: "left",
              value: row.item?.sponsored_sales,
              color: "var(--market-400)",
              min: $options.minMax?.sponsored_sales?.min,
              max: $options.minMax?.sponsored_sales?.max,
              loading: $props.loading,
              width: $options.maxCharCount?.currency?.sponsored_sales
            }, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: row.item?.sponsored_sales,
                charCount: $options.maxCharCount?.currency?.sponsored_sales
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading", "width"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(TACOS)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.TACOS,
          background: "#EBD4F7",
          borderColor: "#CD93EB",
          min: $options.minMax?.TACOS?.min,
          max: $options.minMax?.TACOS?.max,
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.TACOS
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(CVR)": _withCtx(row => [_createVNode(_component_boxed_value, {
          bgColor: $options.getColorsBasedOnRange(row.item?.CVR, $data.CVR_HEATMAP_COLORS),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.CVR,
            limit: 0.1
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["bgColor", "loading"])]),
        "cell(ROAS)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.ROAS,
          background: "#E6E9FE",
          borderColor: "#D8DCFD",
          min: $options.minMax?.ROAS?.min,
          max: $options.minMax?.ROAS?.max,
          loading: $props.loading,
          align: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_number_value, {
            styles: {
              padding: 0
            },
            value: row.item?.ROAS,
            precision: 1
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(units_sold_clicks_14_d)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.units_sold_clicks_14_d,
              loading: $props.loading,
              tight: ""
            }, null, 8, ["value", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(clicks)": _withCtx(row => [_createVNode(_component_number_value, {
          value: row.item?.clicks,
          loading: $props.loading
        }, null, 8, ["value", "loading"])]),
        "cell(CPC)": _withCtx(row => [_createVNode(_component_boxed_value, {
          bgColor: $options.getColorForDecile(row.item?.CPC, $options.minMax?.CPC?.min, $options.minMax?.CPC?.max, $data.CPC_DECILE_COLORS),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.CPC,
            precision: 2,
            config: _ctx.currencyConfig
          }, null, 8, ["value", "config"])]),
          _: 2
        }, 1032, ["bgColor", "loading"])]),
        "cell(sponsored_asin)": _withCtx(row => [_createVNode(_component_bar_with_value, {
          value: row.item?.sponsored_asin,
          color: "#4C8EFF",
          min: $options.minMax?.sponsored_asin?.min,
          max: $options.minMax?.sponsored_asin?.max,
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_number_value, {
            value: row.item?.sponsored_asin,
            charCount: $options.maxCharCount.number?.sponsored_asin,
            style: {
              padding: 0
            }
          }, null, 8, ["value", "charCount"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        _: 1
      }, 8, ["fields", "items", "tbodyTrClass"])]),
      _: 1
    }, 8, ["modelValue", "period"])]),
    _: 3
  }, 8, ["onDownload", "onCopy", "onGoogleSheetDownload", "fields", "loading"]);
}